export const  MAX_LIMIT_RETRY_STATUS = 50
export const  TIME_TO_RETRY_STATUS = 5000
export const  DELAY_TO_REQUEST_STATUS_WORKFLOW = 10000
export const  ADD_QUANTITY_REQUESTS = 1
export const APPROVED_STATUS = 'APPROVED'
export const REJECTED_STATUS = 'REJECTED'
export const RUNNING_STATUS = 'RUNING'